module.exports = __webpack_public_path__ + "static/media/fuelops-full.e20c26d7.svg";